import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-JZL",
  "use": "icon-JZL-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-JZL\"><defs><style type=\"text/css\">@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n</style></defs><path d=\"M128 128v341.333333h768V128H128z m682.666667 256H213.333333V213.333333h597.333334v170.666667zM128 896h768v-341.333333H128v341.333333z m85.333333-256h597.333334v170.666667H213.333333v-170.666667z\" p-id=\"20429\" fill=\"#8a8a8a\" /><path d=\"M682.666667 768l64-85.333333h-128zM746.666667 256h-128L682.666667 341.333333z\" p-id=\"20430\" fill=\"#8a8a8a\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/JZL.svg
// module id = RPDm
// module chunks = 58